
export const SYSTEM = {
  SIS: "sis",
  EDMENTUM: "edmentum",
  AGILIX: "agilix",
  LMS: "IGS-LMS"
};